import React from "react";
import ScreenActivityIndicator from "../feedback/ScreenActivityIndicator";
import { CustomErrorScreen } from "./CustomErrorScreen";

const ScreenRenderingAssistant = (props) => {
  const { contentRenderer, error, loadIsCompleted } = props;

  let panelContent = null;
  if (error) {
    // We've got an error.  Screen needs to use the notifier to display
    // a message, and we just make sure the spinner disappears in this case.
    panelContent = (
      <CustomErrorScreen
        schemaError={error.schemaError}
        authenticationError={error.authenticationError}
      />
    );
  } else if (loadIsCompleted()) {
    // All is well, render the component in its full glory.
    panelContent = contentRenderer();
  } else {
    // Not loaded yet, but no error is recorded, so show the spinner.
    panelContent = <ScreenActivityIndicator />;
  }

  return <>{panelContent}</>;
};

export default ScreenRenderingAssistant;
